import { render, staticRenderFns } from "./tabPrint.vue?vue&type=template&id=0b628c3e&scoped=true&"
import script from "./tabPrint.vue?vue&type=script&lang=js&"
export * from "./tabPrint.vue?vue&type=script&lang=js&"
import style0 from "./tabPrint.vue?vue&type=style&index=0&id=0b628c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b628c3e",
  null
  
)

export default component.exports